import { useCallback } from 'react'

import { useProjectContext, useProjectDispatch } from 'services/Store/Project/hooks'
import { getDecisionTrigger } from 'services/Store/Project/triggers'

import BaseButtonElement from '../BaseButtonElement'
import type { ButtonElementType } from '../buttonTypes'
import { getButtonLabel } from '../helper'

interface IDecisionButtonElementProps extends React.ComponentProps<ButtonElementType> {
  children: React.ReactNode
}

const DecisionButtonElement: React.FC<IDecisionButtonElementProps> = ({
  element,
  block,
  mode,
  styles,
  font,
  children,
}) => {
  const dispatch = useProjectDispatch()
  const trigger = useProjectContext(getDecisionTrigger, {
    blockId: block?.uuid,
    elementValue: element.value,
  })

  const onClick = useCallback(() => {
    if (!trigger.disabled) {
      dispatch(trigger.actionCreator())
    }
    const secondAction = trigger.secondActionCreator?.()
    if (secondAction) {
      dispatch(secondAction)
    }
    const thirdAction = trigger.thirdActionCreator?.()
    if (thirdAction) {
      dispatch(thirdAction)
    }
  }, [dispatch, trigger])

  if (trigger.hide) {
    return null
  }

  const label =
    trigger.label ??
    getButtonLabel(
      {
        'project/questionValidate': element.value.label,
        'project/questionReset': element.value.thirdLabel,
        'project/testEnd': element.value.label,
        'project/setCourseNavigation': element.value.secondLabel,
        'project/courseEnd': element.value.thirdLabel,
        noop: element.value.label,
      },
      trigger.action,
    )

  return (
    <BaseButtonElement
      action={element.value.action}
      disabled={trigger.disabled}
      elementId={element.id}
      font={font}
      label={label}
      mode={mode}
      onClick={onClick}
      styles={styles}
    >
      {children}
    </BaseButtonElement>
  )
}

export default DecisionButtonElement
